import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withKeys as _withKeys, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fcp-loading"
}
const _hoisted_2 = { class: "fcp-head" }
const _hoisted_3 = { class: "fcp-av-wrap" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "fcp-hinfo" }
const _hoisted_7 = { class: "fcp-hname-row" }
const _hoisted_8 = { class: "fcp-hname" }
const _hoisted_9 = {
  key: 0,
  class: "fcp-hphone"
}
const _hoisted_10 = ["title"]
const _hoisted_11 = {
  key: 0,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_12 = {
  key: 1,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.4",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_13 = { class: "fcp-hsub" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "fcp-tag fcp-tag--fluxo"
}
const _hoisted_16 = ["title"]
const _hoisted_17 = {
  key: 0,
  class: "fcp-dd-menu"
}
const _hoisted_18 = ["title"]
const _hoisted_19 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_20 = {
  key: 1,
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_21 = { class: "fcp-toolbar" }
const _hoisted_22 = {
  key: 2,
  class: "fcp-dd-menu fcp-dd-menu--wide"
}
const _hoisted_23 = {
  key: 0,
  class: "fcp-dd-loading"
}
const _hoisted_24 = {
  key: 1,
  class: "fcp-dd-list"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 2,
  class: "fcp-dd-menu fcp-dd-menu--wide"
}
const _hoisted_27 = {
  key: 0,
  class: "fcp-dd-loading"
}
const _hoisted_28 = {
  key: 1,
  class: "fcp-dd-list"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["disabled", "onClick"]
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 0,
  class: "fcp-dd-menu fcp-dd-menu--wide"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 0,
  width: "11",
  height: "11",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"margin-left":"auto","color":"#22c55e"}
}
const _hoisted_35 = {
  key: 0,
  class: "fcp-window-banner"
}
const _hoisted_36 = {
  key: 1,
  class: "fcp-macro-panel"
}
const _hoisted_37 = { class: "fcp-macro-head" }
const _hoisted_38 = { class: "fcp-macro-title" }
const _hoisted_39 = { class: "fcp-macro-form" }
const _hoisted_40 = { class: "fcp-mform-label" }
const _hoisted_41 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_42 = { class: "fcp-macro-head" }
const _hoisted_43 = { class: "fcp-macro-count" }
const _hoisted_44 = {
  key: 0,
  class: "fcp-dd-loading"
}
const _hoisted_45 = {
  key: 1,
  class: "fcp-macro-list"
}
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "fcp-macro-item-name" }
const _hoisted_48 = { class: "fcp-macro-item-sub" }
const _hoisted_49 = {
  key: 0,
  class: "fcp-macro-empty"
}
const _hoisted_50 = { class: "fcp-macro-head" }
const _hoisted_51 = { class: "fcp-macro-title" }
const _hoisted_52 = {
  key: 1,
  class: "fcp-spinner-sm"
}
const _hoisted_53 = {
  key: 0,
  class: "fcp-msgs-loading"
}
const _hoisted_54 = {
  key: 0,
  class: "fcp-load-more"
}
const _hoisted_55 = {
  key: 1,
  class: "fcp-no-more"
}
const _hoisted_56 = {
  key: 0,
  class: "fcp-msg-act"
}
const _hoisted_57 = ["title"]
const _hoisted_58 = ["src", "alt"]
const _hoisted_59 = { key: 1 }
const _hoisted_60 = {
  key: 1,
  class: "fcp-msg-av-spacer"
}
const _hoisted_61 = {
  key: 0,
  class: "fcp-priv-tag"
}
const _hoisted_62 = ["innerHTML"]
const _hoisted_63 = {
  key: 2,
  class: "fcp-att"
}
const _hoisted_64 = ["href"]
const _hoisted_65 = ["src"]
const _hoisted_66 = ["src"]
const _hoisted_67 = ["src"]
const _hoisted_68 = ["href"]
const _hoisted_69 = { class: "fcp-bubble-ts" }
const _hoisted_70 = {
  key: 0,
  class: "copilot-tag",
  title: "Enviada automaticamente pelo copiloto de IA"
}
const _hoisted_71 = {
  key: 2,
  class: "fcp-files"
}
const _hoisted_72 = { class: "fcp-file-name" }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = {
  key: 4,
  class: "fcp-finished",
  role: "status"
}
const _hoisted_75 = ["disabled"]
const _hoisted_76 = ["disabled"]
const _hoisted_77 = ["disabled", "placeholder", "onKeydown"]
const _hoisted_78 = ["disabled"]
const _hoisted_79 = {
  key: 2,
  class: "fcp-empty"
}
const _hoisted_80 = { class: "fcp-tpl-dialog" }
const _hoisted_81 = { class: "fcp-tpl-head" }
const _hoisted_82 = { class: "fcp-tpl-body" }
const _hoisted_83 = { class: "fcp-tpl-list-col" }
const _hoisted_84 = {
  key: 0,
  class: "fcp-dd-loading"
}
const _hoisted_85 = {
  key: 1,
  class: "fcp-macro-empty"
}
const _hoisted_86 = ["onClick"]
const _hoisted_87 = { class: "fcp-tpl-config-col" }
const _hoisted_88 = ["innerHTML"]
const _hoisted_89 = { class: "fcp-mform-label" }
const _hoisted_90 = {
  key: 0,
  class: "fcp-mform-mapped"
}
const _hoisted_91 = ["value", "onInput"]
const _hoisted_92 = ["disabled"]
const _hoisted_93 = {
  key: 1,
  class: "fcp-macro-empty"
}

import { ref, computed, watch, onMounted, onUnmounted, nextTick } from 'vue'
import { useStore } from 'vuex'
import Swal from 'sweetalert2'
import { avatarColor, initials } from '@/composables/useHelpers'
import { fmtPhone } from '@/utils/contactsFormat'
import { toMediaUrl } from '@/utils/media'
import { whatsAppToHtml } from '@/utils/whatsAppText'
import { usePermission } from '@/composables/usePermission'
import { useMessageCacheCp } from '@/composables/useMessageCacheCp'
import { useMessageWindowCp } from '@/composables/useMessageWindowCp'
import { useWhatsappTemplatesCp } from '@/composables/useWhatsappTemplatesCp'
import { onConversationMessage, onConversationStatus, onRealtimeRecovered, type MessageStatusNotification } from '@/composables/useConversationRealtime'
import { useWhatsAppPresence } from '@/composables/useWhatsAppPresence'
import MessageTicks from '@/components/dashboard/MessageTicks.vue'
import CopilotBar from '@/components/dashboard/CopilotBar.vue'
import LinkusCallButton from '@/components/dashboard/LinkusCallButton.vue'
import AgendorMenu from '@/components/agendor/AgendorMenu.vue'
import BotVersionTag from '@/components/dashboard/BotVersionTag.vue'
import { useBotVersionRefresh } from '@/composables/useBotVersionRefresh'
import { playNotificationSound } from '@/composables/useNotificationSound'
import { loadMessageAvatars, senderOf, sameSender } from '@/composables/useMessageAvatars'
import {
  getConversation, getMessages, sendMessage, assignConversation, assignConversationTeam,
  resolveConversation, changeConversationStatus, addConversationTag, removeConversationTag, STATUS_LABEL,
  type ConversationDetail,
} from '@/services/wootdashConversations'
import { listAgents, type CpAgent } from '@/services/wootdashAgents'
import { listTeams, type CpTeam } from '@/services/wootdashTeams'
import { listTags, type CpTag } from '@/services/wootdashTags'
import { uploadAttachment, MAX_ATTACHMENT_BYTES } from '@/services/wootdashAttachments'
import { listMacros, executeMacro, type CpMacro } from '@/services/wootdashMacros'
import type { ChatMessageCp, ProcessedMsgCp } from '@/types/chatCp'

// mobile: tela cheia da MobileView (seta de voltar no lugar do X, layout estreito).
const PAGE_SIZE = 50


export default /*@__PURE__*/_defineComponent({
  __name: 'FocoChatPanel',
  props: {
    conversationId: {},
    mobile: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any) {

// Chat embutido do Modo Foco — construído em paralelo ao ConvDrawer.vue (não reaproveitado
// dele: ConvDrawer é um singleton global sem props, montado uma vez em App.vue e controlado
// por sinais globais; embuti-lo lado a lado da lista do Foco exigiria refatorar um
// componente de 3000+ linhas usado pelo app inteiro — risco/escopo maiores do que faz
// sentido aqui. Reaproveita, sim, os composables/serviços já extraídos e comprovados contra
// o backend real (useMessageCacheCp, useMessageWindowCp, useWhatsappTemplatesCp,
// useConversationRealtime, wootdashConversations/Agents/Teams/Tags/Attachments/Macros)
// — só a orquestração de UI é duplicada, não a integração com o backend.
//
// Deliberadamente fora de escopo (documentado, não esquecido): busca dentro da conversa,
// emoji picker, gravação de áudio/vídeo, histórico de contato, exportar conversa,
// prioridade (não existe no domínio do WootDash) e adiar com prazo (idem — só
// Aberta/Pendente existem aqui).
const props = __props


const store = useStore()
const token = computed(() => store.getters.authUser?.wootdash_token ?? '')
const { can } = usePermission()

const loadingConv = ref(false)
const conv = ref<ConversationDetail | null>(null)
useBotVersionRefresh(conv, () => token.value) // etiqueta da versão do bot sem polling
const { msgCache } = useMessageCacheCp()
const loadingMsgs = ref(false)
const loadingMore = ref(false)
const noMoreMsgs = ref(false)
const draft = ref('')
const files = ref<File[]>([])
const notaInterna = ref(false)
/** Resolvida (2) ou fechada (3): o compositor some e o envio é recusado — reabrir libera. */
const finished = computed(() => conv.value?.status === 2 || conv.value?.status === 3)
const presence = useWhatsAppPresence(token)
const msgsEl = ref<HTMLElement | null>(null)
const taEl = ref<HTMLTextAreaElement | null>(null)
const phoneCopied = ref(false)
const statusMenuOpen = ref(false)
const nowSec = ref(Math.floor(Date.now() / 1000))

function statusClass(status: number): string {
  return ({ 0: 'open', 1: 'pending', 2: 'resolved', 3: 'closed' } as Record<number, string>)[status] ?? 'open'
}

const slaBadge = computed<{ label: string; time: string; status: 'breached' | 'atRisk' } | null>(() => {
  const c = conv.value
  if (!c || !c.slaDueAt) return null
  const due = new Date(c.slaDueAt).getTime() / 1000
  const remaining = due - nowSec.value
  const breached = !!c.slaBreachedAt || remaining <= 0
  if (!breached && remaining > 15 * 60) return null
  const abs = Math.abs(Math.floor(remaining))
  const h = Math.floor(abs / 3600), m = Math.floor((abs % 3600) / 60), s = abs % 60
  const timeStr = (remaining <= 0 ? '+' : '') + (h > 0 ? h + 'h ' : '') + (m > 0 ? m + 'min' : s + 's')
  return { label: c.slaPhase || 'SLA', time: timeStr, status: breached ? 'breached' : 'atRisk' }
})

const processedMsgs = computed<ProcessedMsgCp[]>(() => {
  const msgs = msgCache.value[props.conversationId] || []
  return msgs.map((msg, i) => {
    const next = msgs[i + 1]
    return { ...msg, showAvatar: !sameSender(next, msg) }
  })
})
const canSend = computed(() => draft.value.trim().length > 0 || files.value.length > 0)
const { isWindowClosed: windowClosed } = useMessageWindowCp(processedMsgs, nowSec)
watch(windowClosed, closed => { if (closed) notaInterna.value = false })

function isImageMime(m: string | null) { return !!m && m.startsWith('image/') }
function isAudioMime(m: string | null) { return !!m && m.startsWith('audio/') }
function isVideoMime(m: string | null) { return !!m && m.startsWith('video/') }
/** Foto + nome de quem mandou (atendente pelo senderId, agente de IA, bot, contato) — ver useMessageAvatars. */
function msgSender(msg: ChatMessageCp) {
  return senderOf(msg, { name: conv.value?.contactName, avatarUrl: conv.value?.contactAvatarUrl })
}
function fmtTs(iso: string) {
  const d = new Date(iso)
  return `${d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })} ${d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`
}
async function copyPhone() {
  if (!conv.value?.contactPhone) return
  await navigator.clipboard.writeText(conv.value.contactPhone)
  phoneCopied.value = true
  setTimeout(() => { phoneCopied.value = false }, 2000)
}

/* ── Carregar conversa + mensagens ── */
function mergeMsgs(existing: ChatMessageCp[], incoming: ChatMessageCp[]): ChatMessageCp[] {
  const byId = new Map(existing.map(m => [m.id, m]))
  incoming.forEach(m => byId.set(m.id, m))
  return [...byId.values()].sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime())
}
function isNearBottom(): boolean {
  const el = msgsEl.value
  if (!el) return true
  return el.scrollHeight - el.scrollTop - el.clientHeight < 120
}
function scrollBottom() { if (msgsEl.value) msgsEl.value.scrollTop = msgsEl.value.scrollHeight }

async function fetchMsgs(convId: string, silent = true) {
  if (!silent) loadingMsgs.value = true
  noMoreMsgs.value = false
  const wasNearBottom = isNearBottom()
  try {
    const messages = await getMessages(token.value, convId, { limit: PAGE_SIZE })
    const prevMsgs = msgCache.value[convId]
    if (prevMsgs && messages.some(m => m.senderType === 'Contact' && !prevMsgs.some(p => p.id === m.id))) playNotificationSound()
    msgCache.value = { ...msgCache.value, [convId]: silent && prevMsgs ? mergeMsgs(prevMsgs, messages) : messages }
    noMoreMsgs.value = messages.length < PAGE_SIZE
  } finally {
    loadingMsgs.value = false
    if (convId === props.conversationId && (!silent || wasNearBottom)) { await nextTick(); scrollBottom() }
  }
}

async function loadMoreMsgs() {
  const convId = props.conversationId
  if (loadingMore.value || noMoreMsgs.value) return
  const current = msgCache.value[convId] ?? []
  if (!current.length) return
  loadingMore.value = true
  const prevHeight = msgsEl.value?.scrollHeight ?? 0
  try {
    const older = await getMessages(token.value, convId, { before: current[0].createdAt, limit: PAGE_SIZE })
    if (!older.length) { noMoreMsgs.value = true; return }
    msgCache.value = { ...msgCache.value, [convId]: mergeMsgs(older, current) }
    await nextTick()
    if (msgsEl.value) msgsEl.value.scrollTop = msgsEl.value.scrollHeight - prevHeight
  } finally {
    loadingMore.value = false
  }
}
function onMsgsScroll() { if (msgsEl.value && msgsEl.value.scrollTop < 60) loadMoreMsgs() }

async function loadConversation(id: string) {
  loadingConv.value = true
  void loadMessageAvatars(token.value)
  try {
    conv.value = await getConversation(token.value, id)
    if (props.conversationId !== id) return
    const hadCache = !!msgCache.value[id]
    await fetchMsgs(id, hadCache)
  } finally {
    loadingConv.value = false
  }
}

let msgRealtimeUnsub: (() => void) | null = null

function onRealtimeMsg(convId: string, message: ChatMessageCp) {
  const prevMsgs = msgCache.value[convId]
  if (!prevMsgs) { fetchMsgs(convId, true); return }
  const isNewIncoming = message.senderType === 'Contact' && !prevMsgs.some(m => m.id === message.id)
  const wasNearBottom = isNearBottom()
  msgCache.value = { ...msgCache.value, [convId]: mergeMsgs(prevMsgs, [message]) }
  if (isNewIncoming) playNotificationSound()
  if (isNewIncoming && convId === props.conversationId) presence.seen(convId)
  if (convId === props.conversationId && wasNearBottom) nextTick(scrollBottom)
}

/* ── Enviar ── */
const sending = ref(false)
// Copiloto: a sugestão entra no campo (o atendente revisa e envia); avisamos o envio pra medir o aproveitamento.
const copilotBar = ref<InstanceType<typeof CopilotBar> | null>(null)
function fillFromCopilot(text: string) {
  draft.value = text
  nextTick(() => growTa())
}

async function sendMsg() {
  const convId = props.conversationId
  if (sending.value || finished.value || (!draft.value.trim() && !files.value.length)) return
  sending.value = true
  const text = draft.value.trim()
  const pickedFiles = [...files.value]
  const isPrivate = notaInterna.value
  draft.value = ''
  files.value = []
  nextTick(() => { growTa(); taEl.value?.focus() })
  try {
    if (text) {
      const ok = await sendMessage(token.value, convId, text, isPrivate)
      if (!ok) throw new Error('Falha ao enviar texto')
      if (!isPrivate) copilotBar.value?.sent(text)
    }
    presence.sent()
    const failed: string[] = []
    for (const file of pickedFiles) {
      const uploaded = file.size > MAX_ATTACHMENT_BYTES ? null : await uploadAttachment(token.value, file)
      if (!uploaded || !(await sendMessage(token.value, convId, null, isPrivate, uploaded))) failed.push(file.name)
    }
    if (failed.length) {
      Swal.fire({ title: 'Anexo não enviado', text: `Não foi possível enviar: ${failed.join(', ')}. O limite é 25 MB por arquivo.`, icon: 'warning' })
    }
    await fetchMsgs(convId, true)
  } catch {
    Swal.fire({ title: 'Erro ao enviar', text: 'Não foi possível enviar a mensagem.', icon: 'error' })
  } finally {
    sending.value = false
  }
}
function onFilePick(e: Event) {
  const input = e.target as HTMLInputElement
  if (input.files) { files.value.push(...Array.from(input.files)); input.value = '' }
}
function growTa() {
  const el = taEl.value
  if (!el) return
  el.style.height = 'auto'
  el.style.height = Math.min(el.scrollHeight, 120) + 'px'
}

/* ── Status ── */
async function doChangeStatus(status: 'Open' | 'Pending') {
  if (!conv.value) return
  statusMenuOpen.value = false
  const ok = await changeConversationStatus(token.value, conv.value.id, status)
  if (ok) conv.value = { ...conv.value, status: status === 'Open' ? 0 : 1 }
}
async function doResolve() {
  if (!conv.value) return
  statusMenuOpen.value = false
  const result = await Swal.fire({
    title: 'Resolver esta conversa?', icon: 'warning', showCancelButton: true,
    confirmButtonColor: '#BC0C24', cancelButtonColor: '#6b7280', confirmButtonText: 'Sim, resolver', cancelButtonText: 'Cancelar', reverseButtons: true,
  })
  if (!result.isConfirmed) return
  const ok = await resolveConversation(token.value, conv.value.id)
  if (ok) conv.value = { ...conv.value, status: 2 }
}

/* ── Agente ── */
const agentMenuOpen = ref(false)
const agentLoading = ref(false)
const allAgents = ref<CpAgent[]>([])
const agentSearch = ref('')
let agentsFetched = false
const filteredAgents = computed(() => {
  const q = agentSearch.value.toLowerCase().trim()
  // Modo observador nunca recebe conversa: fica fora da lista de atribuição.
  const assignable = allAgents.value.filter(a => !a.isObserver)
  return q ? assignable.filter(a => `${a.firstName} ${a.lastName}`.toLowerCase().includes(q)) : assignable
})
async function fetchAgents() {
  if (agentLoading.value || agentsFetched) return
  agentsFetched = true
  agentLoading.value = true
  try { allAgents.value = (await listAgents(token.value)).agents } catch { agentsFetched = false } finally { agentLoading.value = false }
}
watch(agentMenuOpen, open => { if (open) fetchAgents() })
async function doAssignAgent(agentId: string) {
  if (!conv.value) return
  agentMenuOpen.value = false
  const agent = allAgents.value.find(a => a.id === agentId)
  const ok = await assignConversation(token.value, conv.value.id, agentId)
  if (ok && agent) conv.value = { ...conv.value, agentId: agent.id, agentName: `${agent.firstName} ${agent.lastName}` }
}

/* ── Time ── */
const teamMenuOpen = ref(false)
const teamsLoading = ref(false)
const allTeams = ref<CpTeam[]>([])
const teamSearch = ref('')
let teamsFetched = false
const filteredTeams = computed(() => {
  const q = teamSearch.value.toLowerCase().trim()
  return q ? allTeams.value.filter(t => t.name.toLowerCase().includes(q)) : allTeams.value
})
async function fetchTeamsOnce() {
  if (teamsFetched) return
  teamsFetched = true
  teamsLoading.value = true
  try { allTeams.value = await listTeams(token.value) } finally { teamsLoading.value = false }
}
watch(teamMenuOpen, open => { if (open) fetchTeamsOnce() })
async function doAssignTeam(teamId: string) {
  if (!conv.value) return
  teamMenuOpen.value = false
  const team = allTeams.value.find(t => t.id === teamId)
  const ok = await assignConversationTeam(token.value, conv.value.id, teamId)
  if (ok && team) conv.value = { ...conv.value, teamId: team.id, teamName: team.name }
}

/* ── Etiquetas ── */
const tagsMenuOpen = ref(false)
const updatingTags = ref(false)
const allTags = ref<CpTag[]>([])
async function fetchTagsOnce() { if (!allTags.value.length) allTags.value = await listTags(token.value) }
watch(tagsMenuOpen, open => { if (open) fetchTagsOnce() })
function isTagProtected(name: string) { return allTags.value.find(t => t.name === name)?.isProtected ?? false }
async function toggleTag(name: string) {
  if (!conv.value || updatingTags.value) return
  const c = conv.value
  const tag = allTags.value.find(t => t.name === name)
  if (!tag) return
  const has = c.tagNames.includes(name)
  updatingTags.value = true
  try {
    const ok = has ? await removeConversationTag(token.value, c.id, tag.id) : await addConversationTag(token.value, c.id, tag.id)
    if (ok) conv.value = { ...c, tagNames: has ? c.tagNames.filter(n => n !== name) : [...c.tagNames, name] }
  } finally {
    updatingTags.value = false
  }
}

/* ── Macros ── */
const macroPanelOpen = ref(false)
const macrosList = ref<CpMacro[]>([])
const macrosLoading = ref(false)
const macroSearch = ref('')
const macroRunning = ref(false)
const macroRunDone = ref(false)
const macroRunningObj = ref<CpMacro | null>(null)
const macroResult = ref<{ success: boolean; failureReason: string; actionsApplied: number } | null>(null)
const macroFormTarget = ref<CpMacro | null>(null)
const macroFormValues = ref<Record<string, string>>({})

const macroFormFields = computed(() => {
  if (!macroFormTarget.value) return []
  const fields: { key: string; label: string }[] = []
  const seen = new Set<string>()
  for (const action of macroFormTarget.value.actions) {
    if (action.type !== 'send_webhook_with_form' || !action.fields) continue
    for (const f of action.fields) if (!seen.has(f.key)) { seen.add(f.key); fields.push(f) }
  }
  return fields
})
const filteredMacros = computed(() => {
  const q = macroSearch.value.trim().toLowerCase()
  return q ? macrosList.value.filter(m => m.name.toLowerCase().includes(q)) : macrosList.value
})
async function loadMacrosOnce() {
  if (macrosList.value.length) return
  macrosLoading.value = true
  try { macrosList.value = await listMacros(token.value) } finally { macrosLoading.value = false }
}
function toggleMacroPanel() {
  macroPanelOpen.value = !macroPanelOpen.value
  if (macroPanelOpen.value) { loadMacrosOnce(); resetMacroRun() }
}
function resetMacroRun() {
  macroRunning.value = false; macroRunDone.value = false; macroRunningObj.value = null
  macroResult.value = null; macroFormTarget.value = null; macroFormValues.value = {}
}
function runMacroRow(macro: CpMacro) {
  const hasForm = macro.actions.some(a => a.type === 'send_webhook_with_form' && a.fields?.length)
  if (hasForm) { macroFormValues.value = {}; macroFormTarget.value = macro; return }
  executeMacroRow(macro, undefined)
}
function submitMacroForm() {
  if (!macroFormTarget.value) return
  const macro = macroFormTarget.value
  const values = { ...macroFormValues.value }
  macroFormTarget.value = null
  executeMacroRow(macro, values)
}
async function executeMacroRow(macro: CpMacro, formValues: Record<string, string> | undefined) {
  if (!conv.value) return
  macroRunningObj.value = macro
  macroRunning.value = true
  macroRunDone.value = false
  macroResult.value = await executeMacro(token.value, macro.id, conv.value.id, formValues)
  macroRunning.value = false
  macroRunDone.value = true
  fetchMsgs(conv.value.id, true)
}

/* ── Templates ── */
const {
  tplOpen, tplsLoading, tplsApproved, tplSel, tplVarNums, tplVars, tplVarMapping,
  tplSending, tplPreviewHtml, openTplModal, closeTplModal, selectTpl, setTplVar, sendTpl, mappedLabel,
} = useWhatsappTemplatesCp({
  getToken: () => token.value,
  getConversationId: () => conv.value?.id ?? null,
  onSent: () => { if (conv.value) fetchMsgs(conv.value.id, true) },
})

// Precisa vir depois de agentMenuOpen/teamMenuOpen/tagsMenuOpen/macroPanelOpen (usados no
// callback) — com immediate:true o callback roda na hora que watch() é chamado, então
// declarar isso antes dessas consts dispara "Cannot access before initialization" (TDZ).
watch(() => props.conversationId, id => {
  statusMenuOpen.value = false
  agentMenuOpen.value = false
  teamMenuOpen.value = false
  tagsMenuOpen.value = false
  macroPanelOpen.value = false
  draft.value = ''
  files.value = []
  msgRealtimeUnsub?.()
  const offMsg = onConversationMessage(id, message => onRealtimeMsg(id, message))
  const offStatus = onConversationStatus(id, evt => onRealtimeStatus(id, evt))
  // Conexão voltou depois de cair: busca o que chegou na queda e junta com o que já está na tela.
  const offRecovered = onRealtimeRecovered(() => fetchMsgs(id, true))
  msgRealtimeUnsub = () => { offMsg(); offStatus(); offRecovered() }
  loadConversation(id)
  presence.seen(id)
}, { immediate: true })

/** Tique novo (enviada/entregue/lida/falhou) numa mensagem já na tela. */
function onRealtimeStatus(convId: string, evt: MessageStatusNotification) {
  const msgs = msgCache.value[convId]
  if (!msgs?.some(m => m.id === evt.messageId)) return
  msgCache.value = {
    ...msgCache.value,
    [convId]: msgs.map(m => m.id === evt.messageId ? { ...m, deliveryStatus: evt.status, deliveryError: evt.error } : m),
  }
}
function onVisibleAgain() {
  if (document.visibilityState === 'visible') presence.seen(props.conversationId)
}

let nowTimer: ReturnType<typeof setInterval> | null = null
onMounted(() => {
  nowTimer = setInterval(() => { nowSec.value = Math.floor(Date.now() / 1000) }, 30_000)
  document.addEventListener('visibilitychange', onVisibleAgain)
})
onUnmounted(() => {
  if (nowTimer) clearInterval(nowTimer)
  document.removeEventListener('visibilitychange', onVisibleAgain)
  msgRealtimeUnsub?.()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["fcp-col", { 'fcp-col--mobile': __props.mobile }])
  }, [
    (loadingConv.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[33] || (_cache[33] = [
          _createElementVNode("span", { class: "fcp-spinner" }, null, -1)
        ]))]))
      : (conv.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_2, [
              (__props.mobile)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "fcp-icon-btn fcp-back",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                    title: "Voltar"
                  }, [...(_cache[34] || (_cache[34] = [
                    _createElementVNode("svg", {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: "fcp-av",
                  style: _normalizeStyle({ background: _unref(avatarColor)(conv.value.contactName) })
                }, [
                  (conv.value.contactAvatarUrl)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _unref(toMediaUrl)(conv.value.contactAvatarUrl)!,
                        alt: conv.value.contactName,
                        onError: _cache[1] || (_cache[1] = (e) => (e.target as HTMLImageElement).style.display='none')
                      }, null, 40, _hoisted_4))
                    : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(initials)(conv.value.contactName)), 1))
                ], 4),
                _createElementVNode("span", {
                  class: _normalizeClass(["fcp-status-dot", statusClass(conv.value.status)])
                }, null, 2)
              ]),
              _createVNode(LinkusCallButton, {
                variant: "light",
                "conversation-id": conv.value.id,
                phone: conv.value.contactPhone,
                "contact-name": conv.value.contactName
              }, null, 8, ["conversation-id", "phone", "contact-name"]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(conv.value.contactName), 1),
                  _createVNode(AgendorMenu, {
                    "contact-id": conv.value.contactId,
                    "conversation-id": conv.value.id,
                    "conversation-agent-id": conv.value.agentId,
                    "contact-name": conv.value.contactName,
                    variant: "light"
                  }, null, 8, ["contact-id", "conversation-id", "conversation-agent-id", "contact-name"]),
                  (conv.value.contactPhone)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                        _createTextVNode(_toDisplayString(_unref(fmtPhone)(conv.value.contactPhone)) + " ", 1),
                        _createElementVNode("button", {
                          class: _normalizeClass(["fcp-phone-copy", { copied: phoneCopied.value }]),
                          onClick: copyPhone,
                          title: phoneCopied.value ? 'Copiado!' : 'Copiar número'
                        }, [
                          (phoneCopied.value)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_11, [...(_cache[35] || (_cache[35] = [
                                _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                              ]))]))
                            : (_openBlock(), _createElementBlock("svg", _hoisted_12, [...(_cache[36] || (_cache[36] = [
                                _createElementVNode("rect", {
                                  x: "9",
                                  y: "9",
                                  width: "13",
                                  height: "13",
                                  rx: "2"
                                }, null, -1),
                                _createElementVNode("path", { d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" }, null, -1)
                              ]))]))
                        ], 10, _hoisted_10)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  (conv.value.teamName)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(conv.value.teamName) + " · ", 1))
                    : _createCommentVNode("", true),
                  (conv.value.flowName)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(conv.value.flowName), 1))
                    : _createCommentVNode("", true),
                  (conv.value.bot)
                    ? (_openBlock(), _createBlock(BotVersionTag, {
                        key: 2,
                        bot: conv.value.bot
                      }, null, 8, ["bot"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    class: _normalizeClass(["fcp-tag", 'fcp-tag--' + statusClass(conv.value.status)])
                  }, _toDisplayString(_unref(STATUS_LABEL)[conv.value.status]), 3),
                  (slaBadge.value)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 3,
                        class: _normalizeClass(["fcp-tag fcp-tag--sla", slaBadge.value.status])
                      }, [
                        _createElementVNode("strong", null, _toDisplayString(slaBadge.value.time), 1),
                        _createTextVNode(" " + _toDisplayString(slaBadge.value.label), 1)
                      ], 2))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_unref(can)('messages.changeStatus'))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "fcp-dd-wrap",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createElementVNode("button", {
                      class: "fcp-icon-btn",
                      title: `Status: ${_unref(STATUS_LABEL)[conv.value.status]}`,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (statusMenuOpen.value = !statusMenuOpen.value))
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["fcp-s-dot", statusClass(conv.value.status)])
                      }, null, 2)
                    ], 8, _hoisted_16),
                    (statusMenuOpen.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          (conv.value.status !== 0)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "fcp-sopt",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (doChangeStatus('Open')))
                              }, [...(_cache[37] || (_cache[37] = [
                                _createElementVNode("span", { class: "fcp-s-dot open" }, null, -1),
                                _createTextVNode(" Abrir", -1)
                              ]))]))
                            : _createCommentVNode("", true),
                          (conv.value.status !== 2)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "fcp-sopt",
                                onClick: doResolve
                              }, [...(_cache[38] || (_cache[38] = [
                                _createElementVNode("span", { class: "fcp-s-dot resolved" }, null, -1),
                                _createTextVNode(" Resolver", -1)
                              ]))]))
                            : _createCommentVNode("", true),
                          (conv.value.status !== 1)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                class: "fcp-sopt",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (doChangeStatus('Pending')))
                              }, [...(_cache[39] || (_cache[39] = [
                                _createElementVNode("span", { class: "fcp-s-dot pending" }, null, -1),
                                _createTextVNode(" Pendente", -1)
                              ]))]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_unref(can)('messages.runMacro'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: _normalizeClass(["fcp-icon-btn", { active: macroPanelOpen.value }]),
                    onClick: toggleMacroPanel,
                    title: macroPanelOpen.value ? 'Voltar à conversa' : 'Executar macro'
                  }, [
                    (!macroPanelOpen.value)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_19, [...(_cache[40] || (_cache[40] = [
                          _createElementVNode("polygon", { points: "5 3 19 12 5 21 5 3" }, null, -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_20, [...(_cache[41] || (_cache[41] = [
                          _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" }, null, -1)
                        ]))]))
                  ], 10, _hoisted_18))
                : _createCommentVNode("", true),
              (!__props.mobile)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    class: "fcp-icon-btn",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('close'))),
                    title: "Fechar conversa"
                  }, [...(_cache[42] || (_cache[42] = [
                    _createElementVNode("svg", {
                      width: "12",
                      height: "12",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "3",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      _createElementVNode("line", {
                        x1: "18",
                        y1: "6",
                        x2: "6",
                        y2: "18"
                      }),
                      _createElementVNode("line", {
                        x1: "6",
                        y1: "6",
                        x2: "18",
                        y2: "18"
                      })
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_21, [
              (_unref(can)('messages.assignAgent'))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "fcp-dd-wrap",
                    onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    (conv.value.agentName)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "fcp-pill fcp-pill--sel",
                          onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (agentMenuOpen.value = !agentMenuOpen.value), ["stop"]))
                        }, _toDisplayString(conv.value.agentName), 1))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "fcp-pill fcp-pill--add",
                          onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (agentMenuOpen.value = !agentMenuOpen.value), ["stop"]))
                        }, "+ agente")),
                    (agentMenuOpen.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((agentSearch).value = $event)),
                            class: "fcp-dd-search",
                            placeholder: "Buscar agente…",
                            onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"])),
                            onKeydown: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
                          }, null, 544), [
                            [_vModelText, agentSearch.value]
                          ]),
                          (agentLoading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [...(_cache[43] || (_cache[43] = [
                                _createElementVNode("span", { class: "fcp-spinner-sm" }, null, -1)
                              ]))]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredAgents.value, (a) => {
                                  return (_openBlock(), _createElementBlock("button", {
                                    key: a.id,
                                    class: _normalizeClass(["fcp-dd-opt", { active: conv.value.agentId === a.id }]),
                                    onClick: _withModifiers(($event: any) => (doAssignAgent(a.id)), ["stop"])
                                  }, _toDisplayString(a.firstName) + " " + _toDisplayString(a.lastName), 11, _hoisted_25))
                                }), 128))
                              ]))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_unref(can)('messages.assignTeam'))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "fcp-dd-wrap",
                    onClick: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    (conv.value.teamName)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "fcp-pill fcp-pill--sel",
                          onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (teamMenuOpen.value = !teamMenuOpen.value), ["stop"]))
                        }, _toDisplayString(conv.value.teamName), 1))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "fcp-pill fcp-pill--add",
                          onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (teamMenuOpen.value = !teamMenuOpen.value), ["stop"]))
                        }, "+ time")),
                    (teamMenuOpen.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((teamSearch).value = $event)),
                            class: "fcp-dd-search",
                            placeholder: "Buscar time…",
                            onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"])),
                            onKeydown: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"]))
                          }, null, 544), [
                            [_vModelText, teamSearch.value]
                          ]),
                          (teamsLoading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [...(_cache[44] || (_cache[44] = [
                                _createElementVNode("span", { class: "fcp-spinner-sm" }, null, -1)
                              ]))]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTeams.value, (t) => {
                                  return (_openBlock(), _createElementBlock("button", {
                                    key: t.id,
                                    class: _normalizeClass(["fcp-dd-opt", { active: conv.value.teamId === t.id }]),
                                    onClick: _withModifiers(($event: any) => (doAssignTeam(t.id)), ["stop"])
                                  }, _toDisplayString(t.name), 11, _hoisted_29))
                                }), 128))
                              ]))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conv.value.tagNames, (name) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: name,
                  class: "fcp-pill fcp-pill--tag"
                }, [
                  _createTextVNode(_toDisplayString(name) + " ", 1),
                  (!isTagProtected(name))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "fcp-pill-x",
                        disabled: updatingTags.value,
                        onClick: _withModifiers(($event: any) => (toggleTag(name)), ["stop"])
                      }, "×", 8, _hoisted_30))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              (_unref(can)('messages.manageTags'))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "fcp-dd-wrap",
                    onClick: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createElementVNode("button", {
                      class: "fcp-pill fcp-pill--add",
                      disabled: updatingTags.value,
                      onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (tagsMenuOpen.value = !tagsMenuOpen.value), ["stop"]))
                    }, "+ etiqueta", 8, _hoisted_31),
                    (tagsMenuOpen.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allTags.value, (tag) => {
                            return (_openBlock(), _createElementBlock("label", {
                              key: tag.id,
                              class: "fcp-dd-opt fcp-dd-opt--check",
                              onClick: _withModifiers(($event: any) => ((conv.value.tagNames.includes(tag.name) && tag.isProtected) || toggleTag(tag.name)), ["prevent"])
                            }, [
                              _createElementVNode("span", {
                                class: "fcp-lbl-dot",
                                style: _normalizeStyle({ background: tag.color })
                              }, null, 4),
                              _createTextVNode(" " + _toDisplayString(tag.name) + " ", 1),
                              (conv.value.tagNames.includes(tag.name))
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_34, [...(_cache[45] || (_cache[45] = [
                                    _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                  ]))]))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_33))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_unref(windowClosed))
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [...(_cache[46] || (_cache[46] = [
                  _createElementVNode("svg", {
                    width: "13",
                    height: "13",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "12",
                      r: "10"
                    }),
                    _createElementVNode("line", {
                      x1: "12",
                      y1: "8",
                      x2: "12",
                      y2: "12"
                    }),
                    _createElementVNode("line", {
                      x1: "12",
                      y1: "16",
                      x2: "12.01",
                      y2: "16"
                    })
                  ], -1),
                  _createElementVNode("span", null, "Você só pode responder usando um template — janela de 24h do WhatsApp encerrada", -1)
                ]))]))
              : _createCommentVNode("", true),
            (macroPanelOpen.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  (macroFormTarget.value && !macroRunning.value && !macroRunDone.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("button", {
                            class: "fcp-macro-back",
                            onClick: _cache[21] || (_cache[21] = ($event: any) => (macroFormTarget.value = null))
                          }, "‹ Voltar"),
                          _createElementVNode("span", _hoisted_38, _toDisplayString(macroFormTarget.value.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _cache[47] || (_cache[47] = _createElementVNode("p", { class: "fcp-mform-hint" }, "Preencha os campos antes de executar", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(macroFormFields.value, (field) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: field.key,
                              class: "fcp-mform-field"
                            }, [
                              _createElementVNode("label", _hoisted_40, _toDisplayString(field.label || field.key), 1),
                              _withDirectives(_createElementVNode("input", {
                                class: "fcp-mform-input",
                                "onUpdate:modelValue": ($event: any) => ((macroFormValues.value[field.key]) = $event),
                                placeholder: field.label || field.key
                              }, null, 8, _hoisted_41), [
                                [_vModelText, macroFormValues.value[field.key]]
                              ])
                            ]))
                          }), 128)),
                          _createElementVNode("button", {
                            class: "fcp-btn-primary",
                            onClick: submitMacroForm
                          }, "Executar")
                        ])
                      ], 64))
                    : (!macroRunning.value && !macroRunDone.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", _hoisted_42, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((macroSearch).value = $event)),
                              class: "fcp-macro-search",
                              placeholder: "Buscar macro…"
                            }, null, 512), [
                              [_vModelText, macroSearch.value]
                            ]),
                            _createElementVNode("span", _hoisted_43, _toDisplayString(filteredMacros.value.length), 1)
                          ]),
                          (macrosLoading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [...(_cache[48] || (_cache[48] = [
                                _createElementVNode("span", { class: "fcp-spinner-sm" }, null, -1)
                              ]))]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMacros.value, (m) => {
                                  return (_openBlock(), _createElementBlock("button", {
                                    key: m.id,
                                    class: "fcp-macro-item",
                                    onClick: ($event: any) => (runMacroRow(m))
                                  }, [
                                    _createElementVNode("span", _hoisted_47, _toDisplayString(m.name), 1),
                                    _createElementVNode("span", _hoisted_48, _toDisplayString(m.actions.length) + " ação" + _toDisplayString(m.actions.length !== 1 ? 'ões' : ''), 1)
                                  ], 8, _hoisted_46))
                                }), 128)),
                                (!filteredMacros.value.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, "Nenhuma macro encontrada"))
                                  : _createCommentVNode("", true)
                              ]))
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("div", _hoisted_50, [
                            (macroRunDone.value)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "fcp-macro-back",
                                  onClick: resetMacroRun
                                }, "‹ Voltar"))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_51, _toDisplayString(macroRunningObj.value?.name), 1),
                            (macroRunning.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_52))
                              : _createCommentVNode("", true)
                          ]),
                          (macroRunDone.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["fcp-macro-summary", macroResult.value?.success ? 'ok' : 'warn'])
                              }, _toDisplayString(macroResult.value?.success ? `Concluído — ${macroResult.value.actionsApplied} ação(ões) aplicada(s)` : `Falhou: ${macroResult.value?.failureReason}`), 3))
                            : _createCommentVNode("", true)
                        ], 64))
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", {
              class: "fcp-msgs",
              ref_key: "msgsEl",
              ref: msgsEl,
              onScroll: onMsgsScroll
            }, [
              (loadingMsgs.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [...(_cache[49] || (_cache[49] = [
                    _createElementVNode("span", { class: "fcp-spinner" }, null, -1)
                  ]))]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (loadingMore.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [...(_cache[50] || (_cache[50] = [
                          _createElementVNode("span", { class: "fcp-spinner-sm" }, null, -1)
                        ]))]))
                      : (noMoreMsgs.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, "início da conversa"))
                        : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processedMsgs.value, (msg) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: msg.id,
                        class: _normalizeClass(["fcp-msg-row", { out: msg.senderType === 'Agent', inn: msg.senderType === 'Contact' || msg.senderType === 'Bot', act: msg.senderType === 'System' }])
                      }, [
                        (msg.senderType === 'System')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(msg.body), 1))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (msg.showAvatar)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "fcp-msg-av",
                                    style: _normalizeStyle({ background: msgSender(msg).color }),
                                    title: msgSender(msg).name
                                  }, [
                                    (msgSender(msg).avatarUrl)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: msgSender(msg).avatarUrl!,
                                          alt: msgSender(msg).name,
                                          onError: _cache[23] || (_cache[23] = (e) => (e.target as HTMLImageElement).style.display = 'none')
                                        }, null, 40, _hoisted_58))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(msgSender(msg).initials), 1))
                                  ], 12, _hoisted_57))
                                : (_openBlock(), _createElementBlock("div", _hoisted_60)),
                              _createElementVNode("div", {
                                class: _normalizeClass(["fcp-bubble", { priv: msg.isPrivateNote }])
                              }, [
                                (msg.isPrivateNote)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_61, "Nota interna"))
                                  : _createCommentVNode("", true),
                                (msg.body)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      class: "fcp-bubble-text",
                                      innerHTML: _unref(whatsAppToHtml)(msg.body)
                                    }, null, 8, _hoisted_62))
                                  : _createCommentVNode("", true),
                                (msg.mediaUrl)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                      (isImageMime(msg.mediaMimeType))
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            href: _unref(toMediaUrl)(msg.mediaUrl)!,
                                            target: "_blank",
                                            rel: "noopener"
                                          }, [
                                            _createElementVNode("img", {
                                              src: _unref(toMediaUrl)(msg.mediaUrl)!,
                                              class: "fcp-att-img",
                                              alt: "imagem",
                                              loading: "lazy"
                                            }, null, 8, _hoisted_65)
                                          ], 8, _hoisted_64))
                                        : (isAudioMime(msg.mediaMimeType))
                                          ? (_openBlock(), _createElementBlock("audio", {
                                              key: 1,
                                              src: _unref(toMediaUrl)(msg.mediaUrl)!,
                                              controls: "",
                                              class: "fcp-att-audio"
                                            }, null, 8, _hoisted_66))
                                          : (isVideoMime(msg.mediaMimeType))
                                            ? (_openBlock(), _createElementBlock("video", {
                                                key: 2,
                                                src: _unref(toMediaUrl)(msg.mediaUrl)!,
                                                controls: "",
                                                preload: "metadata",
                                                class: "fcp-att-video"
                                              }, null, 8, _hoisted_67))
                                            : (_openBlock(), _createElementBlock("a", {
                                                key: 3,
                                                href: _unref(toMediaUrl)(msg.mediaUrl)!,
                                                target: "_blank",
                                                rel: "noopener",
                                                class: "fcp-att-file"
                                              }, "📎 Anexo", 8, _hoisted_68))
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", _hoisted_69, [
                                  (msg.origin === 'copilot')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_70, "IA"))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(_toDisplayString(fmtTs(msg.createdAt)), 1),
                                  (msg.senderType !== 'Contact' && !msg.isPrivateNote)
                                    ? (_openBlock(), _createBlock(MessageTicks, {
                                        key: 1,
                                        status: msg.deliveryStatus,
                                        error: msg.deliveryError
                                      }, null, 8, ["status", "error"]))
                                    : _createCommentVNode("", true)
                                ])
                              ], 2)
                            ], 64))
                      ], 2))
                    }), 128))
                  ], 64))
            ], 544), [
              [_vShow, !macroPanelOpen.value]
            ]),
            (files.value.length && !macroPanelOpen.value && !finished.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (f, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: "fcp-file-pill"
                    }, [
                      _createElementVNode("span", _hoisted_72, _toDisplayString(f.name), 1),
                      _createElementVNode("button", {
                        class: "fcp-file-rm",
                        onClick: ($event: any) => (files.value.splice(i, 1))
                      }, "×", 8, _hoisted_73)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (!finished.value)
              ? (_openBlock(), _createBlock(CopilotBar, {
                  key: 3,
                  ref_key: "copilotBar",
                  ref: copilotBar,
                  "conversation-id": __props.conversationId,
                  draft: draft.value,
                  onFill: fillFromCopilot
                }, null, 8, ["conversation-id", "draft"]))
              : _createCommentVNode("", true),
            (finished.value && !macroPanelOpen.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                  _cache[51] || (_cache[51] = _createElementVNode("svg", {
                    width: "15",
                    height: "15",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true"
                  }, [
                    _createElementVNode("rect", {
                      x: "3",
                      y: "11",
                      width: "18",
                      height: "11",
                      rx: "2"
                    }),
                    _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
                  ], -1)),
                  _createElementVNode("span", null, "Conversa " + _toDisplayString(conv.value.status === 3 ? 'fechada' : 'resolvida') + ": não dá pra enviar mensagem, anexo nem template.", 1),
                  (_unref(can)('messages.changeStatus'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "fcp-finished-btn",
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (doChangeStatus('Open')))
                      }, "Reabrir"))
                    : _createCommentVNode("", true)
                ]))
              : (!macroPanelOpen.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 5,
                    class: _normalizeClass(["fcp-composer", { priv: notaInterna.value }])
                  }, [
                    _createElementVNode("label", {
                      class: _normalizeClass(["fcp-attach-btn", { disabled: _unref(windowClosed) || notaInterna.value }])
                    }, [
                      _createElementVNode("input", {
                        type: "file",
                        multiple: "",
                        hidden: "",
                        disabled: _unref(windowClosed) || notaInterna.value,
                        onChange: onFilePick
                      }, null, 40, _hoisted_75),
                      _cache[52] || (_cache[52] = _createElementVNode("svg", {
                        width: "15",
                        height: "15",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, [
                        _createElementVNode("path", { d: "M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" })
                      ], -1))
                    ], 2),
                    (_unref(can)('messages.privateNote'))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: _normalizeClass(["fcp-priv-btn", { active: notaInterna.value }]),
                          disabled: _unref(windowClosed),
                          onClick: _cache[25] || (_cache[25] = ($event: any) => (notaInterna.value = !notaInterna.value)),
                          title: "Nota interna"
                        }, [...(_cache[53] || (_cache[53] = [
                          _createElementVNode("svg", {
                            width: "14",
                            height: "14",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2.2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("rect", {
                              x: "3",
                              y: "11",
                              width: "18",
                              height: "11",
                              rx: "2"
                            }),
                            _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
                          ], -1)
                        ]))], 10, _hoisted_76))
                      : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("textarea", {
                      ref_key: "taEl",
                      ref: taEl,
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((draft).value = $event)),
                      class: "fcp-ta",
                      rows: "1",
                      disabled: _unref(windowClosed),
                      placeholder: notaInterna.value ? 'Nota interna… (Enter envia)' : (_unref(windowClosed) ? 'Envie um template para responder…' : 'Mensagem… (Enter envia)'),
                      onKeydown: _withKeys(_withModifiers(sendMsg, ["exact","prevent"]), ["enter"]),
                      onInput: _cache[27] || (_cache[27] = ($event: any) => {growTa(); _unref(presence).typing(props.conversationId, notaInterna.value)})
                    }, null, 40, _hoisted_77), [
                      [_vModelText, draft.value]
                    ]),
                    (!notaInterna.value && _unref(windowClosed) && _unref(can)('messages.sendTemplate'))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "fcp-tpl-btn",
                          onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_unref(openTplModal) && _unref(openTplModal)(...args))),
                          title: "Enviar template WhatsApp"
                        }, "Template"))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          class: "fcp-send-btn",
                          disabled: !canSend.value || sending.value,
                          onClick: sendMsg
                        }, [...(_cache[54] || (_cache[54] = [
                          _createElementVNode("svg", {
                            width: "15",
                            height: "15",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2.5",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("line", {
                              x1: "22",
                              y1: "2",
                              x2: "11",
                              y2: "13"
                            }),
                            _createElementVNode("polygon", { points: "22 2 15 22 11 13 2 9 22 2" })
                          ], -1)
                        ]))], 8, _hoisted_78))
                  ], 2))
                : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_79, [
            _cache[55] || (_cache[55] = _createElementVNode("p", null, "Conversa não encontrada.", -1)),
            (__props.mobile)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "fcp-btn-primary",
                  onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.$emit('close')))
                }, "Voltar"))
              : _createCommentVNode("", true)
          ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_unref(tplOpen))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fcp-tpl-overlay",
            onMousedown: _cache[32] || (_cache[32] = _withModifiers(
//@ts-ignore
(...args) => (_unref(closeTplModal) && _unref(closeTplModal)(...args)), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("span", null, "Enviar Template WhatsApp → " + _toDisplayString(conv.value?.contactName), 1),
                _createElementVNode("button", {
                  class: "fcp-icon-btn",
                  onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_unref(closeTplModal) && _unref(closeTplModal)(...args)))
                }, [...(_cache[56] || (_cache[56] = [
                  _createElementVNode("svg", {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.5"
                  }, [
                    _createElementVNode("path", { d: "M18 6 6 18M6 6l12 12" })
                  ], -1)
                ]))])
              ]),
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("div", _hoisted_83, [
                  (_unref(tplsLoading))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_84, [...(_cache[57] || (_cache[57] = [
                        _createElementVNode("span", { class: "fcp-spinner-sm" }, null, -1)
                      ]))]))
                    : (!_unref(tplsApproved).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_85, "Nenhum template aprovado"))
                      : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tplsApproved), (t) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: t.id,
                      class: _normalizeClass(["fcp-tpl-item", { active: _unref(tplSel)?.id === t.id }]),
                      onClick: ($event: any) => (_unref(selectTpl)(t))
                    }, _toDisplayString(t.name.replace(/_/g, ' ')), 11, _hoisted_86))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_87, [
                  (_unref(tplSel))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", {
                          class: "fcp-tpl-preview",
                          innerHTML: _unref(tplPreviewHtml)
                        }, null, 8, _hoisted_88),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tplVarNums), (n) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: n,
                            class: "fcp-mform-field"
                          }, [
                            _createElementVNode("label", _hoisted_89, "Variável {{" + _toDisplayString(n) + "}}", 1),
                            (_unref(tplVarMapping)[n])
                              ? (_openBlock(), _createElementBlock("span", _hoisted_90, "Preenchido automaticamente: " + _toDisplayString(_unref(mappedLabel)(n)), 1))
                              : (_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  class: "fcp-mform-input",
                                  value: _unref(tplVars)[n] || '',
                                  onInput: ($event: any) => (_unref(setTplVar)(n, ($event.target as HTMLInputElement).value))
                                }, null, 40, _hoisted_91))
                          ]))
                        }), 128)),
                        _createElementVNode("button", {
                          class: "fcp-btn-primary",
                          disabled: _unref(tplSending),
                          onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_unref(sendTpl) && _unref(sendTpl)(...args)))
                        }, _toDisplayString(_unref(tplSending) ? 'Enviando…' : `Enviar para ${conv.value?.contactName}`), 9, _hoisted_92)
                      ], 64))
                    : (_openBlock(), _createElementBlock("p", _hoisted_93, "Selecione um template ao lado"))
                ])
              ])
            ])
          ], 32))
        : _createCommentVNode("", true)
    ]))
  ], 2))
}
}

})